export default __webpack_public_path__ + "static/media/MP0039.9d5afe38.jpg";